import CreateForm from '@/components/local-material/create/Create.vue'
import ImportMaterialForm from '@/components/local-material/import-material/ImportMaterial.vue'
import TaskPage from '@/components/local-material/task/Task.vue'
import cropperPage from '@/components/local-material/cropper/Cropper.vue'
import CreateFolderForm from '@/components/local-material/createFolder/CreateFolder.vue'
import CreateZmForm from '@/components/local-material/create-zm/CreateZm.vue'
import MediaRecordPage from '@/components/local-material/mediaRecord/MediaRecord.vue'
import PushRecordsModal from '@/components/local-material/pushRecords/PushRecords.vue'

import { getFolders, getMaterials, deleteMaterial, clearFolders } from '@/api/local-material'
import { getMaterialUploaders, getJuliangEmails, getDiskCapacity } from '@/api/open'
import { Empty } from 'ant-design-vue';
import moment from 'moment'

import { getCorporations, getMaterialTags } from '@/api/open'
import MediaRecordCreateForm from '@/components/local-material/mediaRecord/create/Create.vue'
import CreateAdTaskForm from '@/components/local-material/create-ad-task/create/Create.vue'
import KuaishouUpload from '@/views/sys/ad-task/kuaishou/upload/Upload.vue'
import JuliangUpload from '@/views/sys/ad-task/juliang/upload/Upload.vue'
import JumpJuliangPage from '@/views/sys/advertiser/jump-juliang/JumpJuliang.vue'
import SyncToOrganization from '@/components/local-material/syncToOrganization/SyncToOrganization.vue'
import BatchUpload from '@/components/local-material/batch-upload/BatchUpload.vue'

export default {
    name: 'local_material',
    components: {
        CreateForm,
        CreateFolderForm,
        MediaRecordPage,
        moment,
        cropperPage,
        PushRecordsModal,
        MediaRecordCreateForm,
        KuaishouUpload,
        JuliangUpload,
        JumpJuliangPage,
        ImportMaterialForm,
        TaskPage,
        CreateZmForm,
        CreateAdTaskForm,
        SyncToOrganization,
        BatchUpload,
    },
    props: {
        filters: {
            type: Object,
            default: () => ({}), 
        },
    },
    data() {
        return {
            data: [],
            pagination: {
                defaultPageSize: 12,
                showSizeChanger: true,
                onShowSizeChange: this.pageSizeChange,
                pageSizeOptions: ['10', '20', '30', '40', '60', '80', '100'],
                onChange: this.changePage,
                showTotal: (total) => {
                    return ' 共 ' + total + ' 条'
                },
            },
            loading: false,
            materialLoading: false,
            corporations: [],
            medias: [],
            columns: [],
            model: {},
            queryParam: {},
            showForm: false,
            showImportForm: false,
            showFolderForm: false,
            showZmForm: false,
            showTaskPage: false,
            tabIndex: 1, //标签ID
            treeData: [],
            replaceFields: {
                title: 'name',
                key: 'id',
                value: 'id'
            },
            pid: null,
            simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
            previewVisible: false,
            preview: {},
            selectedRow: [],
            selectedIds: [],
            downloadNotice: '',
            showCropper: false,
            uploaders: false,
            breadcrumb: [{ pid: 0, id: 0, name: '根目录' }],
            pos: '',
            types: [{id:2,name:'图片'},{id:3,name:'视频'},],
            materialTags: [],
            showMediaRecordPage: false,
            showPushRecords: false,
            showUploadForm: false,
            canDel: false,
            showUpload: false,
            showJuliangUpload: false,
            showJumpJuliangPage: false,
            emails:[],
            taskModel: {},
            diskCapacity: {
                used: 0,
                total: 0,
                unit: 'GB',
                percent: 0  // 确保初始化是数字
            },
            diskCapacity2: {
                used: 0,
                total: 0,
                unit: 'GB',
                percent: 0  // 确保初始化是数字
            },
            dragging: false,
            offsetX: 0,
            offsetY: 0,
            dirSearch: '',
            filteredTreeData: [],
            expandedKeys: [],
            isTrash: false,
            selecting:false,
            showCreateAdTaskForm: false,
            showSyncToOrganization: false,
            syncOrgModel: {},
            showBatchUpload: false,
        }
    },
    created() {
        this.$nextTick(() => {
            // 禁用右键
            document.oncontextmenu = new Function('event.returnValue=false')
        })
    },
    computed: {
        diskColor() {
            if (this.diskCapacity.percent >= 80) {
                return '#ff4d4f'; // 红色
            } else if (this.diskCapacity.percent >= 50) {
                return '#faad14'; // 黄色
            } else {
                return '#52c41a'; // 绿色
            }
        }
    },
    beforeDestroy() {
        this.$nextTick(() => {
            // 禁用右键
            document.oncontextmenu = new Function('event.returnValue=true')
        })
    },
    watch: {
        treeData(newVal) {
            // 目录数据改变时，重置 filtered 与展开状态
            this.filteredTreeData = newVal || []
            this.expandedKeys = []
        }
    },
    mounted() {
        this.filteredTreeData = this.treeData || []
        getCorporations().then(res => { this.corporations = res.data.list || {} })
        getMaterialTags().then(res => { this.materialTags = res.data.list || {} })
        getMaterialUploaders().then(res => { this.uploaders = res.data.list || {} })
        // 磁盘容量统计已隐藏，不再请求接口
        // this.getDiskInfo()
        this.getData()
    },
    methods: {
        create(event, record, action) {
            if (record) {
                event.stopPropagation(); // 阻止事件冒泡
            }
            if (record === null) {
                this.createFolder(record, action)
                this.showForm = false
            } else if (record.id && record.type == 1) {
                this.createFolder(record, action)
                this.showForm = false
            } else {
                this.model = record.id ? Object.assign({}, record) : { pid: this.pid, action: action, name: null, video_custom_cover: null, }
                this.model.action = action
                if (!record.id) {
                    this.model.name = null
                    this.model.video_custom_cover = null
                }

                this.showForm = true
            }
        },
        importMaterial(event) {
            event.stopPropagation(); // 阻止事件冒泡
            // is_enhance: 是否叠加角标 + 拼接片尾（默认 1-开启）
            this.model = { worker_id: null, pid: this.pid, file: null, is_zm:0, is_enhance:0 }
            this.showImportForm = true
        },
        showTask() {
            this.taskModel = { pid: this.pid}
            this.showTaskPage = true
        },
        createFolder(record, action) {
            if (record === null) {
                this.model =  { pid: this.pid, action: action, name: null }
                this.model.materials = this.selectedRow
                this.model.action = action
            } else {
                this.model = record.id ? Object.assign({}, record) : { pid: this.pid, action: action, name: null }
                this.model.pid = this.model.pid > 0 ? this.model.pid : null
                this.model.action = action
            }
        
            this.showFolderForm = true
        },
        pageSizeChange(val, pageSize) {
            this.loading = true
            this.pagination.defaultPageSize = pageSize
            this.pagination.current = 1
        },
        changePage(page, pageSize) {
            this.pagination.defaultPageSize = pageSize
            this.pagination.current = page
            //获取列表
            this.getMaterials()
        },
        handleTableChange(pagination) {
            const pager = { ...this.pagination }
            pager.current = pagination.current
            this.pagination = pager
            this.getMaterials()
        },
        getData() {
            //获取目录树
            this.getFolders()
            //获取列表
            this.getMaterials()
        },
        getFolders() {
            //获取所有的目录
            getFolders({corporation_id: this.queryParam.corporation_id}).then(res => {
                this.treeData = res.data.list || {}
                this.treeData.unshift({ id: 0, name: '根目录', pid: 0, children: [] })
            })
        },
        removeSelectedIds() {
            if (!(this.filters && this.filters.isBatchSelect)) {
                this.selectedRow = []
                this.selectedIds = []
            }
        },
        getMaterials() {
            this.removeSelectedIds()

            this.loading = true
            const pagination = { ...this.pagination }
            this.queryParam.type = 0

            if (this.tabIndex == 1) {
                //没有pid,读取顶级目录
                if (!this.pid) {
                    this.queryParam.type = 1
                    this.queryParam.pid = 0
                } else {
                    this.queryParam.type = 0
                    this.queryParam.pid = this.pid
                }
            } else {
                //去除pid
                delete this.queryParam.pid;
                this.queryParam.type = [2, 3]
            }
            const json = Object.assign({}, this.queryParam, {
                page: pagination.current,
                page_size: pagination.defaultPageSize
            })


            getMaterials(json).then(res => {
                pagination.total = res.data.total
                this.loading = false
                this.data = res.data.list
                this.pagination = pagination
                this.canDel = res.data.can_del
            }).catch(() => {
                this.loading = false
            })
        },
        refresh() {
            this.getData()
        },
        search() {
            // source_server 筛选也触发切到素材管理tab
            if (this.queryParam.admin_id || this.queryParam.name || this.queryParam.upload_day || this.queryParam.material_type || this.queryParam.material_tag_ids || this.queryParam.source_server) {
                this.tabClick(2)
            } else {
                this.pagination.current = 1
                this.getData()
            }
        },
        resetSearch() {
            this.tabClick(1)
            this.queryParam = {}
            this.getData()
        },
        accessTo(route) {
            return this.$helper.accessTo('LocalMaterialController', route)
        },
        destroy(record) {
            const del = ids => {
                deleteMaterial(ids).then(res => {
                    this.$message.destroy()
                    if (res && res.code === 0) {
                        this.$message.success('删除成功')
                        this.refresh()
                    }
                })
            }
            let delIds = []
            if (!record) {
                delIds = this.selectedIds
            } else {
                delIds = [record.id]
            }
            del(delIds)
        },
        tabClick(key) {
            this.removeSelectedIds()

            this.tabIndex = key
            this.pid = 0
            this.queryParam.type = 0

            this.pagination.current = 1
            //获取列表
            this.getMaterials()
            if (key == 1) {
                this.getFolders()
            }

            this.breadcrumb = [{ pid: 0, id: 0, name: '根目录' }]
        },
        onSelect(keys, e) {
            // 是否垃圾站
            this.isTrash = e.node.dataRef && e.node.dataRef.name === '垃圾站'

            this.removeSelectedIds()
            this.pid = keys[0]

            if (e.node.pos.split('-')[1] != this.pos.split('-')[1]) {
                this.breadcrumb = []
            }
            this.pos = e.node.pos

            //改变面包屑
            this.changeBreadcrumb(e.node.dataRef)

            this.pagination.current = 1
            //获取列表
            this.getMaterials()
        },
        clickFolder(event, record) {
            if (record) {
                event.stopPropagation(); // 阻止事件冒泡
            }

            const pid = record.id
            // console.log('目录被点击了', record)

            this.removeSelectedIds()
            //改变面包屑
            this.clickBreadcrumb(record, true)

            this.pid = pid
            this.pagination.current = 1
            //获取列表
            this.getMaterials()
        },
        clickMaterial(event, item, type = 1) {
            if (item) {
                event.stopPropagation(); // 阻止事件冒泡
            }
            this.previewVisible = true

            const timestamp = Date.now();
            if (item.file_url.includes('?t=')) {
                item.file_url = item.file_url.replace(/(\?t=)[^&]*/, `$1${timestamp}`);
                item.video_cover = item.video_cover.replace(/(\?t=)[^&]*/, `$1${timestamp}`);
                item.video_custom_cover = item.video_custom_cover?item.video_custom_cover.replace(/(\?t=)[^&]*/, `$1${timestamp}`):null;
            } else {
                item.file_url += '?t=' + timestamp
                item.video_cover += '?t=' + timestamp
                item.video_custom_cover += '?t=' + timestamp
            }

            this.preview = item
            this.preview.show_reject_reason = type == 2 ? true : false //是否展示未审核原因
            const filteredTags = this.materialTags.filter(tag => item.material_tag_ids.includes(tag.id));
            this.preview.materialTags = filteredTags
        },
        previewCancel() {
            this.previewVisible = false
        },
        checkFilters(item) {
            // 同步到巨量 或 同步到组织，二选一即可选中
            if (this.filters.need_sync_juliang_or_organize) {
                const syncedJuliang = !!(item.madia_record && item.madia_record.status == 2)
                const syncedOrg = !!(item.madia_org_record && item.madia_org_record.status == 2)
                if (!syncedJuliang && !syncedOrg) {
                    return '请先同步到巨量或巨量组织'
                }
            } else {
                if (this.filters.need_sync_juliang && !(item.madia_record  && item.madia_record.status == 2)) {
                    return '请先同步到巨量'
                }
                if (this.filters.need_sync_juliang_organize && !(item.madia_org_record && item.madia_org_record.status == 2)) {
                    return '请先同步到巨量组织'
                }
            }

            if (this.filters.type && item.type != this.filters.type) {
                return '类型不一致！'
            }
            if (this.filters.size && item.size > this.filters.size * 1024 * 1024) {
                return '素材要求小于' + this.filters.size + "M"
            }

            if (this.filters.ratio && parseFloat(item.width / item.height).toFixed(1) != this.filters.ratio) {
                return '素材宽高比例不符合要求！'
            }
            let widthHeightErrror = ''
            if (this.filters.width && item.width > this.filters.width) {
                widthHeightErrror = '素材宽度要求小于' + this.filters.width + '像素'
            }
            if (this.filters.height && item.height > this.filters.height) {
                widthHeightErrror += '，素材高度要求小于' + this.filters.height + '像素'
            }

            if (this.filters.fixedWidth && item.width != this.filters.fixedWidth) {
                widthHeightErrror = '素材宽度要求等于' + this.filters.fixedWidth + '像素'
            }
            if (this.filters.fixedHeight && item.height != this.filters.fixedHeight) {
                widthHeightErrror += '，素材高度要求等于' + this.filters.fixedHeight + '像素'
            }

            if (widthHeightErrror) {
                return widthHeightErrror
            }
            return null
        },
        choiceMaterial(item) {
            console.log('item', item)
            let errorMsg = this.checkFilters(item)
            if (errorMsg) {
                return this.$message.error(errorMsg)
            }
            //调用父组件方法
            this.$emit('success', item);
        },
        // 复选框改变事件处理方法
        handleCheckboxChange(item) {
            // 新增拦截
            if (
                this.filters.from_local_select &&
                item.reject_reason && item.reject_reason.id
            ) {
                return this.$message.warning('该素材存在审核建议，无法选择')
            }

            if (!this.showSelect(item)) {
                return false
            }
            const index = this.selectedRow.indexOf(item);
            if (index === -1) {
                this.selectedRow.push(item); // 选中项加入数组
            } else {
                this.selectedRow.splice(index, 1); // 取消选中项从数组中移除
            }

            this.selectedIds = []
            this.selectedRow.forEach(element => {
                this.selectedIds.push(element.id)
            });
            // console.log('当前选中的是', this.selectedIds)
        },
        getFileExtension(url) {
            // 使用split方法将URL按斜杠分割成数组
            const urlParts = url.split('/');

            // 获取数组中的最后一个元素，即文件名
            const fileName = urlParts[urlParts.length - 1];

            // 使用split方法将文件名按点号分割成数组
            const fileNameParts = fileName.split('.');

            // 获取数组中的最后一个元素，即文件后缀
            const fileExtension = fileNameParts[fileNameParts.length - 1];
            return fileExtension
        },
        async downloadMaterial() {
            if (this.selectedRow.length === 0) {
                return this.$message.error('请先选择素材');
            }
            let selectedUrls = []
            let selectedMaterial = []
            let types = []

            let errorMsg = ''
            this.selectedRow.forEach(element => {
                console.log('aaa', element)
                //检查是否有下载权限
                if (element.can_down) {
                    if (element.type == 1) {
                        types.push(element.type)
                    } else {
                        selectedUrls.push(element.file_url)
                        selectedMaterial.push({ url: element.file_url, name: element.name })
                    }
                } else {
                    errorMsg += element.name + '，'
                }

              
            });

            if (selectedUrls.length <= 0) {
                return this.$message.error('以下素材没有下载权限：' + errorMsg);
            }

            if (types.includes(1)) {
                return this.$message.error('请勿选择素材组下载！');
            }

            this.materialLoading = true

            // 遍历选中的行
            selectedMaterial.forEach((row) => {
                let { name, url } = row;
                url += "?name=" + name
                const iframe = document.createElement("iframe");
                iframe.style.display = "none"; // 防止影响页面
                iframe.style.height = 0; // 防止影响页面
                iframe.src = url;
                document.body.appendChild(iframe); // 这一行必须，iframe挂在到dom树上才会发请求

                // 5分钟之后删除
                // setTimeout(()=>{
                //   iframe.remove();
                // }, 5 * 60 * 1000);

            });

            this.materialLoading = false

        },
        clickCropper(event, item) {
            event.stopPropagation(); // 阻止事件冒泡
            this.model = item
            this.showCropper = true
        },
        clickMediaRecord(event, item) {
            event.stopPropagation(); // 阻止事件冒泡
            this.model = item
            this.showMediaRecordPage = true
        },
        showSelect(record) {
            let isShow = true
            if (this.filters && this.filters.type) {
                //满足条件才显示可选框
                if (record.type != 1 && this.filters.type == record.type && !this.checkFilters(record)) {
                    // 新增逻辑：如果是巨量任务本地素材入口，并且有审核建议 → 禁止选中
                if (
                    this.filters.from_local_select &&
                    record.reject_reason && record.reject_reason.id
                ) {
                    return false
                }
                    isShow = true
                } else {
                    isShow = false
                }
            }
            return isShow
        },
        batchChoiceMaterial() {
            //当前选中的素材
            if (this.selectedIds.length <= 0) {
                return this.$message.error('请选择素材')
            }
            if (this.selectedIds.length > this.filters.num) {
                return this.$message.error('超过最多可选素材 （' + this.selectedIds.length + ' / ' + this.filters.num + '）')
            }
            this.selectedRow.forEach(element => {
                //获取所有的素材
                let errorMsg = this.checkFilters(element)
                if (errorMsg) {
                    return this.$message.error(errorMsg)
                }
            });
            //调用父组件方法
            this.$emit('success', this.selectedRow);
        },
        clickBreadcrumb(record, isAdd = false) {
            let thisData = { pid: record.pid, id: record.id, name: record.name };
            // console.log(thisData)
            let index = this.breadcrumb.findIndex(item => item.pid === record.pid);
            if (isAdd != true && index !== -1) {
                // 找到匹配的元素，修改该元素并丢弃之后的所有数据
                this.breadcrumb.splice(index, this.breadcrumb.length - index, thisData);
            } else if (!this.breadcrumb.some(item => item.id === undefined)) {
                // 不存在匹配的元素且不存在没有id的元素，创建一个新的元素并添加到数组中
                this.breadcrumb.push(thisData);
            }

            //开始跳转
            this.removeSelectedIds()
            this.pid = record.id
            this.pagination.current = 1
            //获取列表
            this.getMaterials()
        },
        changeBreadcrumb(record) {
            let pos
            if (record.pos) {
                pos = record.pos
            } else {
                pos = []
            }

            //判断自己在不在，不在加入
            let index = pos.findIndex(item => item.id === record.id);
            if (index === -1) {
                pos.push({ pid: record.pid, id: record.id, name: record.name })
            }

            this.breadcrumb = pos
        },
        uploadToMedia (type = 1, media = 2) {
              //当前选中的素材
            if (this.selectedIds.length <= 0) {
                return this.$message.error('请选择素材')
            }
            this.model.media = media
            this.showUploadForm = true
            this.model.media_name = '巨量'
            this.model.mediaStr = 'juliang'
            if (media == 1) {
                this.model.media_name = '快手'
                this.model.mediaStr = 'kuaishou'
            } 
            this.model.local_material_ids = this.selectedIds
            this.model.up_type = type
        },
        selectAll () {
            if(this.selecting) return
            this.selecting = true

            // console.log('点击一键全选功能！')
            this.data.forEach(item => {
                if (!this.showSelect(item)) {
                    return false
                }
                const index = this.selectedRow.indexOf(item);
                // if (index === -1) {
                if (index === -1 && !this.selectedRow.some(row => row.id === item.id)) {
                    this.selectedRow.push(item); // 选中项加入数组
                } else {
                    this.selectedRow.splice(index, 1); // 取消选中项从数组中移除
                }
            })
           
            this.selectedIds = []
            this.selectedRow.forEach(element => {
                this.selectedIds.push(element.id)
            });
            // console.log('当前选中的是', this.selectedIds)

            setTimeout(()=>{
                this.selecting = false
            }, 200)
        },
        uploadToKuaishou() {
            this.model =  {file_url:null, advertiser_id: null, shield_backward_switch:false}
            this.showUpload = true
        },
        uploadToJuliang() {
            this.model =  {file_url:null, advertiser_id: null, advertiser_ids: null}
            this.showJuliangUpload = true
        },
        accessToAdvertiser(route) {
            return this.$helper.accessTo('AdvertiserController', route)
        },
        clickJuliang (out_id = null)
        {
            let url
            if (out_id) {
                url = 'https://ad.oceanengine.com/promotion/promote-manage/ad?aadvid=' + out_id
            } else {
                url = "https://business.oceanengine.com/site/account-manage/ad/bidding/superior/account"
            }
            getJuliangEmails({out_id:out_id}).then(res => { 
                this.emails = res.data.list || [] 
                //没有绑定邮箱，直接跳转
                if (this.emails.length < 1 ) {
                    window.open(url, '_blank')
                } else {
                    //开启弹窗，选择巨量邮箱跳转
                    this.jumpJuliangModel = {
                        out_id: out_id,
                        url: url,
                        emails: this.emails
                    }
                    this.showJumpJuliangPage = true
                }
            })
        },
        createZm ()
        {
            this.model.selectedIds = this.selectedIds
            this.showZmForm = true
        },
        getDiskInfo() {
            getDiskCapacity().then(res => {
                this.diskCapacity = res.data || {}
                this.diskCapacity.percent = Number(((res.data.used / res.data.total) * 100).toFixed(2));
                this.diskCapacity2 = res.data.disk2 || {}
                this.diskCapacity2.percent = Number(((res.data.disk2.used / res.data.disk2.total) * 100).toFixed(2));
            })
        },
        startDrag(e) {
            this.dragging = true;
            this.offsetX = e.clientX - this.$refs.floatingStatsBox.getBoundingClientRect().left;
            this.offsetY = e.clientY - this.$refs.floatingStatsBox.getBoundingClientRect().top;
            document.addEventListener('mousemove', this.onDrag);
            document.addEventListener('mouseup', this.stopDrag);
        },
        onDrag(e) {
            if (!this.dragging) return;
            const box = this.$refs.floatingStatsBox;
            let left = e.clientX - this.offsetX;
            let top = e.clientY - this.offsetY;

            // 边界限制
            const maxLeft = window.innerWidth - box.offsetWidth;
            const maxTop = window.innerHeight - box.offsetHeight;
            left = Math.min(Math.max(0, left), maxLeft);
            top = Math.min(Math.max(0, top), maxTop);

            box.style.left = left + 'px';
            box.style.top = top + 'px';
            box.style.right = 'auto';
            box.style.bottom = 'auto';
            box.style.position = 'fixed';
        },
        stopDrag() {
            this.dragging = false;
            document.removeEventListener('mousemove', this.onDrag);
            document.removeEventListener('mouseup', this.stopDrag);
        },
        filterTree() {
            const keyword = (this.dirSearch || '').toString().trim().toLowerCase()
            if (!keyword) {
                this.filteredTreeData = this.treeData || []
                this.expandedKeys = []
                return
            }

            const keyField = (this.replaceFields && this.replaceFields.key) ? this.replaceFields.key : 'id'
            const titleField = (this.replaceFields && this.replaceFields.title) ? this.replaceFields.title : 'name'
            const expandedSet = new Set()

            const dfs = (nodes, ancestors = []) => {
                const out = []
                for (const node of nodes || []) {
                    const name = (node[titleField] || '').toString().toLowerCase()
                    const id = node[keyField]
                    // 先递归子节点
                    const children = dfs(node.children || [], ancestors.concat(id))
                    const matched = name.includes(keyword) || (children && children.length > 0)
                    if (matched) {
                        // 把该节点的所有祖先加入 expandedSet（这样路径会被展开）
                        for (const a of ancestors) expandedSet.add(a)
                        // 保留 node（并把过滤后的 children 放进去）
                        out.push({ ...node, children })
                    }
                }
                return out
            }

            this.filteredTreeData = dfs(this.treeData || [], [])
            this.expandedKeys = Array.from(expandedSet)
        },
        clearFolder() {
            clearFolders([this.pid]).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success('清除成功')
                    this.refresh()
                }
            })
        },
        getDiskColor(percent) {
            if (percent >= 80) return '#ff4d4f'
            if (percent >= 50) return '#faad14'
            return '#52c41a'
        },
        openPushRecords() {
          this.showPushRecords = true
      },
      // 同步到巨量组织：以组织维度把选中素材提交到升级版组织
      syncToOrganization () {
          if (this.selectedIds.length <= 0) {
              return this.$message.error('请选择素材')
          }
          this.syncOrgModel = {
              local_material_ids: this.selectedIds,
          }
          this.showSyncToOrganization = true
      },
      createAdTask (type = 1, media = 2) {
            //当前选中的素材
          if (this.selectedIds.length <= 0) {
              return this.$message.error('请选择素材')
          }
          this.model.media = media
          this.showCreateAdTaskForm = true
          this.model.media_name = '巨量'
          this.model.mediaStr = 'juliang'
          if (media == 1) {
              this.model.media_name = '快手'
              this.model.mediaStr = 'kuaishou'
          } 
          this.model.local_material_ids = this.selectedIds
          this.model.up_type = type
      },
      // 清空选中的素材（供父组件调用）
      clearSelected() {
        this.selectedRow = []
        this.selectedIds = []
      },
      isDisabled(item) {
        return (
                this.filters.from_local_select &&
                item.reject_reason && item.reject_reason.id
            )
        }
    }
}
